import React from 'react';
import PropTypes from 'prop-types';

import ButtonBar from 'components/ButtonBar';
import Nav from 'components/Nav';

// Paths that render their own header/layout and should not get the default one
const HEADERLESS_PATHS = [
  'main/training/chapter/',
  'main/fasttrack/chapter/',
  'main/sell/templates-mobile',
  'main/directory',
  'main/sell/directory',
];

const Header = ({ pathname }) => {
  if (HEADERLESS_PATHS.some((path) => pathname.includes(path))) {
    return null;
  }

  return (
    <div className="header">
      <Nav pathname={pathname} />
      {pathname.length < 7 && <ButtonBar className="buttonBar" />}
    </div>
  );
};

export default Header;

Header.propTypes = {
  pathname: PropTypes.string.isRequired,
};
